/**
 * 检测当前是否为 Gphone 环境（Android手机）
 *
 * 判断逻辑：
 * 1. 检查系统标识
 *    - Android
 * 2. 特殊情况
 *    - 套皮鸿蒙（包含 Android 标识）也会被识别为 Gphone
 *
 * @returns {boolean} 如果是 Gphone 环境返回 true，否则返回 false
 *
 * @example
 * ```ts
 * if (isGPhone()) {
 *   useGphoneNativeAPI();
 * }
 * ```
 */
export function isGPhone(): boolean {
  try {
    if (typeof navigator === "undefined" || !navigator.userAgent) {
      return false;
    }

    const ua = navigator.userAgent.toLowerCase();

    // Android 系统检测
    const systems = ["android"];

    return systems.some((keyword) => ua.includes(keyword));
  } catch (error) {
    console.warn("检测Gphone环境失败:", error);
    return false;
  }
}
